// Vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import cn from 'classnames';
// Components
import AppLink from '../../components/AppLink';
import Button from '../../components/Button';
import EntryCard from '../../components/EntryCard';
// Root Styles
import '../../styles/document.styl';
// Styles
import './style.styl';

class Feed extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      className,
      entries,
      total,
      loadEntries,
      targetAuthor,
      user,
      isEntriesLoading,
    } = this.props;
    const isUser = user && user.name && !user.code;

    const isEntries = !!(entries && entries.length);
    const isTargetAuthor = !!(targetAuthor && Object.keys(targetAuthor).length);

    return (
      <section className={cn('Feed', className)}>
        {isTargetAuthor && (
          <div className="Feed__target-author">
            <div className="Feed__target-avatar">
              <img className="Feed__target-avatar-img" src={targetAuthor.avatar} />
            </div>
            <div className="Feed__target-author">
              <div className="Feed__target-author-name">{targetAuthor.author}</div>
              <div className="Feed__target-author-position">{targetAuthor.position}</div>
            </div>
          </div>
        )}

        <div className="Feed__content">
          <div className="Feed__entries">
            {!isEntries && <div className="Feed__message">Таких публикаций пока нет</div>}

            {isEntries &&
              entries.map(item => <EntryCard key={item.id} entry={item} isUser={isUser} />)}

            <AppLink className="Feed__entry Feed__add" href={isUser ? `/new-insight` : `/login`}>
              <div className="Feed__add-img" />
              <div className="Feed__add-title">Поделись опытом</div>
              <div className="Feed__add-description">
                Расскажи о&nbsp;своем продуктовом&nbsp;инсайте сообществу
              </div>
              <div className="Feed__add-link">Добавить публикацию</div>
            </AppLink>
          </div>
        </div>
        {entries.length < parseInt(total) && (
          <div className="Feed__footer">
            <Button
              big
              light
              className="Feed__load-more"
              onClick={loadEntries}
              loading={isEntriesLoading}>
              Показать еще
            </Button>
          </div>
        )}
      </section>
    );
  }
}

Feed.defaultProps = {
  className: '',
  entries: '',
};

Feed.propTypes = {
  className: PropTypes.string,
  entries: PropTypes.array,
  total: PropTypes.number,
  isEntriesLoading: PropTypes.bool,
};

export default Feed;



// WEBPACK FOOTER //
// components/Feed/index.js